export const AUDIO_PLAYER_MODAL_NAME = 'audioPlayer';
